import React from "react";
import { Link } from "react-router-dom";

const Secondrow = () => {
  return (
    <div className="row mt-2 g-3">
      {/* Left Column */}
      <div className="col-md-6 d-flex flex-column justify-content-between">
        <div className="row donate_wrapper g-3">
          {/* First Image */}
          <div className="col-sm-6 col-md-5 d-flex flex-column justify-content-center align-items-center">
            <img
              height="366"
              width="300"
              src="/images/logos/img/Joseph.jpeg"
              alt=""
              style={{ objectFit: "cover", objectPosition: "center", paddingLeft: "40px" }}
            />
            <h4 className="rector-title text-center mt-2">
              Most Rev. Joseph Susainathan - RECTOR
            </h4>
          </div>

          {/* Second Image */}
          <div className="col-6 col-md-7 d-flex flex-column justify-content-center align-items-center">
            <img
              height="366"
              width="300"
              src="/images/logos/img/Sebastian.webp"
              alt=""
              style={{ objectFit: "cover", objectPosition: "center" }}
            />
            <h4 className="rector-title text-center mt-2">
              Rev. Fr. Arockiasamy Sebastian, PARISH PRIEST
            </h4>
          </div>
        </div>
      </div>

      {/* Right Column */}
      <div className="col-md-6 d-flex flex-column justify-content-between">
        <div className="row donate_wrapper g-3">
          {/* Prayer Request */}
          <div className="col-6 col-md-6 d-flex flex-column justify-content-center align-items-center">
            <div className="position-relative w-100">
              <img
                className="w-100"
                height={400}
                src="images/logos/img/prayer-request-1.jpg"
                alt=""
                style={{ objectFit: "cover" }}
              />
              <h4 className="text-white position-absolute top-50 start-50 translate-middle text-center">
                <b>
                  <Link
                    to="/prayer-request"
                    style={{ textDecoration: "none", color: "#fff" }}
                  >
                    PRAYER REQUEST
                  </Link>
                </b>
              </h4>
            </div>
          </div>

          {/* Parish Details */}
          <div className="col-6 col-md-6 d-flex flex-column justify-content-center align-items-center">
            <div className="position-relative w-100">
              <img
                className="w-100"
                height={400}
                src="images/logos/img/church-1.jpg"
                alt=""
                style={{ objectFit: "cover" }}
              />
              <h4 className="text-white position-absolute top-50 start-50 translate-middle text-center">
                <b>
                  <Link
                    to="/parish-details"
                    style={{ textDecoration: "none", color: "#fff" }}
                  >
                    PARISH DETAILS
                  </Link>
                </b>
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Secondrow;
